import React, { useState } from "react";
import { ReactComponent as Arrow } from "../../assets/images/arrow-right.svg";

const typeLabels = {
  balance_settle: "Balance Settle",
  cash_out: "Cash Out",
  complementary_top_up: "Top Up",
  order: "Order",
  order_refund: "Order Refund",
  rfid_assignment: "RFID Assignment",
  rfid_replacement: "RFID Replacement",
  top_up: "Top Up",
  ticket_balance_top_up: "Top Up",
  transfer_in: "Transfer In",
  transfer_out: "Transfer Out",
  voided: "Voided",
  nc_expiry: "NC Expiry",
};

const TransactionCard = ({ transaction = {} }) => {
  const [expanded, setExpanded] = useState(false);

  const isOrder = transaction.type === "order" && transaction.order;
  const amount = transaction.amount / 100;
  const isCredit = transaction.amount >= 0;
  const date = new Date(transaction.createdAt);

  return (
    <div
      className={
        "transaction-card" +
        (isOrder ? " transaction-card--clickable" : "") +
        (expanded ? " transaction-card--expanded" : "")
      }
      onClick={() => isOrder && setExpanded((prev) => !prev)}
    >
      <div className="transaction-card__row">
        <div className="transaction-card__info">
          <h3 className="transaction-card__type">
            {typeLabels[transaction.type] || transaction.type}
            {isOrder && transaction.order.outlet && (
              <span className="transaction-card__outlet">
                {transaction.order.outlet.name}
              </span>
            )}
          </h3>
          <span className="transaction-card__date">
            {date.toLocaleDateString("en-uk")}{" "}
            {date.toLocaleTimeString("en-uk", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </div>
        <div className="transaction-card__amount-container">
          <h3
            className={
              "transaction-card__amount" +
              (isCredit
                ? " transaction-card__amount--credit"
                : " transaction-card__amount--debit")
            }
          >
            {isCredit ? "+" : ""}
            {amount} {transaction.currency}
          </h3>
        </div>
        {isOrder && (
          <Arrow
            className={
              "transaction-card__expand-icon" +
              (expanded ? " transaction-card__expand-icon--expanded" : "")
            }
          />
        )}
      </div>
      {isOrder && expanded && (
        <div className="transaction-card__details">
          {transaction.order.orderItems.map((item) => (
            <div className="transaction-card__item" key={item.pk}>
              <span className="transaction-card__item-qty">
                {item.quantity}x
              </span>
              <span className="transaction-card__item-name">{item.name}</span>
              <span className="transaction-card__item-price">
                {(item.priceAtPurchase * item.quantity) / 100}{" "}
                {transaction.currency}
              </span>
            </div>
          ))}
          <div className="transaction-card__total">
            <span className="transaction-card__total-label">Total</span>
            <span className="transaction-card__total-price">
              {transaction.order.total / 100} {transaction.currency}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionCard;
